import api from './api';

// Get all tickets (based on role: organization tickets for client, all tickets for admin/support)
const getTickets = async (queryParams = {}) => {
  const response = await api.get('/tickets', { params: queryParams });
  return response;
};

// Get my tickets (submitted by me for client, assigned to me for support/admin)
const getMyTickets = async (queryParams = {}) => {
  const response = await api.get('/tickets/my', { params: queryParams });
  return response;
};

// Get tickets stats
const getTicketStats = async () => {
  const response = await api.get('/tickets/stats');
  return response;
};

// Get single ticket
const getTicket = async (id) => {
  const response = await api.get(`/tickets/${id}`);
  return response;
};

// Create new ticket
const createTicket = async (ticketData, files = []) => {
  // If we have files, we need to use FormData
  if (files && files.length > 0) {
    const formData = new FormData();
    
    // Append ticket data
    Object.keys(ticketData).forEach(key => {
      formData.append(key, ticketData[key]);
    });
    
    // Append files
    files.forEach(file => {
      formData.append('attachments', file);
    });
    
    const response = await api.post('/tickets', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response;
  } else {
    // No files, just send JSON
    const response = await api.post('/tickets', ticketData);
    return response;
  }
};

// Update ticket
const updateTicket = async (id, ticketData, files = []) => {
  // If we have files, we need to use FormData
  if (files && files.length > 0) {
    const formData = new FormData();
    
    // Append ticket data
    Object.keys(ticketData).forEach(key => {
      formData.append(key, ticketData[key]);
    });
    
    // Append files
    files.forEach(file => {
      formData.append('attachments', file);
    });
    
    const response = await api.put(`/tickets/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response;
  } else {
    // No files, just send JSON
    const response = await api.put(`/tickets/${id}`, ticketData);
    return response;
  }
};

// Delete ticket
const deleteTicket = async (id) => {
  const response = await api.delete(`/tickets/${id}`);
  return response;
};

// Update ticket status
const updateStatus = async (id, status) => {
  const response = await api.put(`/tickets/${id}/status`, { status });
  return response;
};

// Assign ticket to user
const assignTicket = async (id, userId) => {
  const response = await api.put(`/tickets/${id}/assign`, { assignedTo: userId });
  return response;
};

// Get audit logs of a ticket
const getAuditLogs = async (id) => {
  const response = await api.get(`/tickets/${id}/auditlogs`);
  return response;
};

// Connect tickets
const connectTickets = async (id, ticketIds) => {
  const response = await api.post(`/tickets/${id}/connect`, { ticketIds });
  return response;
};

// Disconnect tickets
const disconnectTickets = async (id, connectedId) => {
  const response = await api.delete(`/tickets/${id}/disconnect/${connectedId}`);
  return response;
};

const exportAllTickets = async (queryParams = {}, format = 'csv') => {
  const response = await api.get('/tickets/export', {
    params: { ...queryParams, format },
    responseType: 'blob'
  });
  return response;
};

const exportMyTickets = async (queryParams = {}, format = 'csv') => {
  const response = await api.get('/tickets/my/export', {
    params: { ...queryParams, format },
    responseType: 'blob'
  });
  return response;
};

const ticketService = {
  getTickets,
  getMyTickets,
  getTicketStats,
  getTicket,
  createTicket,
  updateTicket,
  deleteTicket,
  updateStatus,
  assignTicket,
  getAuditLogs,
  connectTickets,
  disconnectTickets,
  exportAllTickets,
  exportMyTickets
};

export default ticketService;
